import { Col } from 'reactstrap'
import OpeningOfLeafletsGeneral from './OpeningOfLeafletsGeneral'

const OpeningOfLeaflets = () => {
  return (
    <Col xxl="3" xl="4" sm="6">
      <OpeningOfLeafletsGeneral />
    </Col>
  )
}

export default OpeningOfLeaflets  